/** @returns Whether `localStorage.novolibDebug` is `"true"`, which enables the debug utils. */
export function isNovolibDebug(): boolean {
    return localStorage.getItem("novolibDebug") === "true";
}
